import { deepMerge } from 'js/utils/Utils'

const defaults = {
  config: {
    root: null, // scroll area, null = body
    rootMargin: '0px', // -100~100  px, %
    threshold: [0], // 0 ~ 100..n
  },
  useClass: false,
  dataName: {
    observerId: 'observerId',
    autoClear: 'observerAutoClear',
  },
  className: {
    inOneWay: 'is-in',
    inView: 'is-inView',
  },
}

export default class IntersectionObserveManager {
  constructor(options = {}) {
    deepMerge(this, defaults, options)

    this.inViewCallbackList = []
    this.outOfViewCallbackList = []
    this.ovserverCount = 0

    this.intersectionObsever = new IntersectionObserver((...arg) => {
      this.onUpdate(...arg)
    }, this.config)
  }

  onUpdate(entries, observer) {
    entries.forEach((entry, i) => {
      if (entry.isIntersecting) {
        if (this.useClass) {
          entry.target.classList.add(this.className.inOneWay)
          entry.target.classList.add(this.className.inView)
        }

        const data = entry.target.dataset
        const observerId = data[this.dataName.observerId]
        const isAutoClear = typeof data[this.dataName.autoClear] === 'string'

        if (this.inViewCallbackList[observerId]) {
          this.inViewCallbackList[observerId](entry.target, entry)
        }

        if (isAutoClear) {
          this.remove(entry.target)
        }
      } else {
        const data = entry.target.dataset
        const observerId = data[this.dataName.observerId]

        if (this.useClass) {
          entry.target.classList.remove(this.className.inView)
        }
        if (this.outOfViewCallbackList[observerId]) {
          this.outOfViewCallbackList[observerId](entry.target, entry)
        }
      }
    })
  }

  add($element, inViewCallback = null, outOfViewCallback = null) {
    if (!$element) return

    $element.dataset[this.dataName.observerId] = this.ovserverCount

    if (inViewCallback) {
      this.inViewCallbackList[this.ovserverCount] = inViewCallback
    }

    if (outOfViewCallback) {
      this.outOfViewCallbackList[this.ovserverCount] = outOfViewCallback
    }

    this.intersectionObsever.observe($element)
    this.ovserverCount++
  }

  remove($element) {
    if (!$element) return

    const observerId = $element.dataset[this.dataName.observerId]
    if (this.inViewCallbackList[observerId]) {
      this.inViewCallbackList[observerId] = null
    }
    if (this.outOfViewCallbackList[observerId]) {
      this.outOfViewCallbackList[observerId] = null
    }
    $element.dataset[this.dataName.observerId] = ''
    this.intersectionObsever.unobserve($element)
    // this.ovserverCount--
  }

  clear() {
    if (this.intersectionObsever) {
      this.intersectionObsever.disconnect()
    }
    this.options = []
  }

  destroy() {
    this.clear()
    this.intersectionObsever = null
  }
}